import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { ADMIN_BASKETS_API_PATHS } from '../constants/baskets-api-paths.constants';

type BasketPosition = {
  id: string;
  position: number;
};

type UseUpdateBasketsPositionsResult = {
  updatePositions: (baskets: BasketPosition[]) => Promise<boolean>;
  isSubmitting: boolean;
};

export function useUpdateBasketsPositions(): UseUpdateBasketsPositionsResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updatePositions = async (baskets: BasketPosition[]): Promise<boolean> => {
    setIsSubmitting(true);

    try {
      await HttpClient.patch(ADMIN_BASKETS_API_PATHS.UPDATE_POSITIONS, { baskets });

      enqueueSnackbar('Les positions ont été mises à jour', { variant: 'success' });
      return true;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la mise à jour des positions'),
        { variant: 'error' }
      );
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updatePositions, isSubmitting };
}
